import { Route, Routes } from 'react-router-dom';
import { AdminGuard } from './AdminGuard';
import { AdminPage } from './AdminPage';
import { MatchWeeksManagementPage } from './match-weeks/MatchWeeksManagementPage';
import { TeamOfTheWeekPage } from './match-weeks/TeamOfTheWeekPage';
import MatchViewPage from '../main-tabs/competition/MatchViewPage';

export const AdminArea = () => (
  <AdminGuard>
    <Routes>
      <Route index element={<AdminPage />} />
      <Route path="jornadas" element={<MatchWeeksManagementPage />} />
      <Route path="jornadas/:matchWeekId/once" element={<TeamOfTheWeekPage />} />
      <Route
        path="jornadas/partidos/:matchId"
        element={<MatchViewPage backHref="/app/admin/jornadas" headerVariant="admin" />}
      />
      <Route path="*" element={<AdminPage />} />
    </Routes>
  </AdminGuard>
);
